var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJioDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1487_2167)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3535F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3035 9.6499H10.7702C9.75804 9.6499 9.20515 10.2206 9.20515 11.3622V16.868C9.20515 18.2855 8.72634 18.7829 7.60308 18.7829C6.71952 18.7829 6.0016 18.396 5.43064 17.6964C5.37523 17.6229 4.21582 18.1749 4.21582 19.5379C4.21582 21.0108 5.59597 21.9133 8.15656 21.9133C11.2677 21.9133 12.9074 20.348 12.9074 16.9234V11.3622C12.9056 10.222 12.3533 9.6499 11.3035 9.6499ZM23.7035 12.3382C20.6834 12.3382 18.6766 14.2532 18.6766 17.1086C18.6766 20.0366 20.6093 21.9151 23.6478 21.9151C26.6671 21.9151 28.6552 20.0366 28.6552 17.1275C28.657 14.2532 26.6863 12.3382 23.7035 12.3382ZM23.6665 19.206C22.4875 19.206 21.6777 18.3409 21.6777 17.1071C21.6777 15.8923 22.5074 15.0265 23.6665 15.0265C24.8256 15.0265 25.6549 15.8923 25.6549 17.1258C25.6552 18.3222 24.8084 19.206 23.6668 19.206H23.6665ZM16.1249 12.43H15.756C14.8543 12.43 14.1732 12.8532 14.1732 14.1426V20.0348C14.1732 21.3423 14.8363 21.7477 15.7933 21.7477H16.1619C17.0641 21.7477 17.7083 21.3053 17.7083 20.0348V14.1426C17.7083 12.817 17.0828 12.43 16.1249 12.43ZM15.9225 8.15894C14.7806 8.15894 14.0626 8.80368 14.0626 9.81642C14.0626 10.8469 14.7995 11.4914 15.9776 11.4914C17.1192 11.4914 17.8375 10.8469 17.8375 9.81642C17.8375 8.7859 17.1009 8.15894 15.9225 8.15894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1487_2167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJioDot);
export default __webpack_public_path__ + "static/media/jio-dot.54d83118ae962a1301b9166641f576d2.svg";
export { ForwardRef as ReactComponent };